"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADDON_ID = 'COLOR_PICKER_ADDON';
exports.ADDON_NAME = 'withColorPicker';
exports.PANEL_ID = exports.ADDON_ID + "/panel";
exports.PARAMETER_ID = exports.ADDON_ID + "/parameter";
exports.EVENT_SET_THEME = 'EVENT_SET_THEME';
